// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2530": "e96a97f91d26","4879": "66b95d754de6","5461": "4abfb4091f55","7141": "cdec85e31733",}[chunkId] + ".css"
}